import React, {useState, createContext} from "react";

export const CurrentPageContext = createContext();

export const CurrentPageProvider = (props) => {
    const [currentPage, setCurrentPage] = useState("hello");
    
    return(
        <CurrentPageContext.Provider value={[currentPage, setCurrentPage]}>
            {props.children}
        </CurrentPageContext.Provider>
    )
}